/** Códigos de catálogo user_type usados en dashboards por rol. */
export type UserTypeCode =
  | 'ADMINISTRATOR'
  | 'RADIOLOGIST'
  | 'REFERRER'
  | 'DIGITADOR'
  | 'MONITOR'
  | 'DEFAULT';

const USER_TYPE_ORDER = [
  'ADMINISTRATOR',
  'RADIOLOGIST',
  'REFERRER',
  'DIGITADOR',
  'MONITOR',
  'DEFAULT',
] as const;

export function normalizeUserTypeCode(code?: string | null): UserTypeCode | string {
  const raw = (code ?? '').trim().toUpperCase();
  if (!raw) return 'DEFAULT';
  return raw;
}

/** Etiqueta humana para el dashboard (fallback si no hay name del catálogo). */
export function userTypeDashboardLabel(code?: string | null): string {
  switch (normalizeUserTypeCode(code)) {
    case 'ADMINISTRATOR':
      return 'Administrador';
    case 'RADIOLOGIST':
      return 'Médico radiólogo';
    case 'REFERRER':
      return 'Médico referidor';
    case 'DIGITADOR':
      return 'Digitador';
    case 'MONITOR':
      return 'Monitor';
    case 'DEFAULT':
      return 'Usuario general';
    default:
      return String(code ?? 'Usuario');
  }
}

export function sortUserTypes<T extends { code: string }>(types: T[]): T[] {
  return [...types].sort((a, b) => {
    const ai = USER_TYPE_ORDER.indexOf(a.code as (typeof USER_TYPE_ORDER)[number]);
    const bi = USER_TYPE_ORDER.indexOf(b.code as (typeof USER_TYPE_ORDER)[number]);
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });
}

export function userTypeBadgeClass(code?: string): string {
  switch (normalizeUserTypeCode(code)) {
    case 'ADMINISTRATOR':
      return 'bg-medical-500/10 text-medical-400';
    case 'RADIOLOGIST':
      return 'bg-brand-primary/10 text-brand-primary-light';
    case 'REFERRER':
      return 'bg-cyan-500/10 text-cyan-300';
    case 'DIGITADOR':
      return 'bg-brand-secondary/10 text-brand-secondary-light';
    case 'MONITOR':
      return 'bg-amber-500/10 text-amber-300';
    default:
      return 'bg-slate-700 text-slate-300';
  }
}

export function userTypeBadgeBorderClass(code?: string): string {
  switch (normalizeUserTypeCode(code)) {
    case 'ADMINISTRATOR':
      return 'bg-medical-500/20 text-medical-400 border-medical-500/30';
    case 'RADIOLOGIST':
      return 'bg-brand-primary/20 text-brand-primary-light border-brand-primary/30';
    case 'REFERRER':
      return 'bg-cyan-500/20 text-cyan-300 border-cyan-500/30';
    case 'DIGITADOR':
      return 'bg-brand-secondary/20 text-brand-secondary-light border-brand-secondary/30';
    case 'MONITOR':
      return 'bg-amber-500/20 text-amber-300 border-amber-500/30';
    default:
      return 'bg-slate-700/50 text-slate-400 border-slate-600';
  }
}
